import type React from 'react';

interface PennsylvaniaSvgProps {
    color?: string;
    opacity?: number;
}

const PennsylvaniaSvg: React.FC<PennsylvaniaSvgProps> = ({ color = '#5B3FE6', opacity = 0.5 }) => (
    <svg width="50" height="32" viewBox="0 0 50 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity={opacity}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8.72451L3.18182 22.1842L5 31.2786L42.0909 24.0031L42.4545 22.9118L43.1818 22.1842H45L45.3636 21.4567L46.4545 20.7291V20.0016L49 17.8189V17.0914L46.8182 15.6362H46.0909L45.7273 14.1811L44.6364 14.5449L44.2727 13.0898L44.6364 11.9985L45 11.2709L44.2727 10.5434V9.81583L45 9.08828L45.7273 7.63318V6.90563L46.8182 5.8143L46.0909 5.08675H45H43.9091L43.1818 3.99542V3.26787V2.17654L42.0909 1.44899L41.3636 1.81276L41 1.08521L39.9091 0.721436L6.81818 7.63318L6.45455 5.08675L1 8.72451Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8.72451L3.18182 22.1842L5 31.2786L42.0909 24.0031L42.4545 22.9118L43.1818 22.1842H45L45.3636 21.4567L46.4545 20.7291V20.0016L49 17.8189V17.0914L46.8182 15.6362H46.0909L45.7273 14.1811L44.6364 14.5449L44.2727 13.0898L44.6364 11.9985L45 11.2709L44.2727 10.5434V9.81583L45 9.08828L45.7273 7.63318V6.90563L46.8182 5.8143L46.0909 5.08675H45H43.9091L43.1818 3.99542V3.26787V2.17654L42.0909 1.44899L41.3636 1.81276L41 1.08521L39.9091 0.721436L6.81818 7.63318L6.45455 5.08675L1 8.72451Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default PennsylvaniaSvg;
